import React, {Fragment, useReducer} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import {CORNER_SHELVES_POSITIONS} from "../../../core/constants";
import WithClickCount from "../../../hocs/withClickCount";
import {featureInterface} from "../../../../../interfaces/featureInterface";
// import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const leftRightArray = {
  "left": CORNER_SHELVES_POSITIONS.slice(0,3),
  "right": CORNER_SHELVES_POSITIONS.slice(3,6)
};

const GroheFeatureOptionsShelfSide = (props) => {

  const {lookActiveFeature, updateCanvasCount, intl} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const featureGroup = lookActiveFeature.getParent();

  const optionsButtonClick = (position, maxClickCountReached) => {
    // const featureLabel = (Analytics.getStringForAnalytics(getValueText(option.metaValue))).toLowerCase() + "_" + Analytics.getSkuForAnalytics(lookActiveFeature);
    // const analyticsLabel = IS_PRODUCT_JOURNEY
    //   ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureOptions + featureLabel
    //   : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureOptions + featureLabel;
    // Analytics.sendClickEvent(analyticsLabel);

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    featureGroup.layerPositions[position] = featureGroup.layerPositions[position] ? null : featureGroup.getMatchingPositionFeature(position);
    if (featureGroup.layerPositions[position] && featureGroup.disabled) {
      featureGroup.disabled = false;
    }

    updateCanvasCount();
    forceUpdate();
  };

  const getValueText = (metaValue) => {
    switch (metaValue) {
      case CORNER_SHELVES_POSITIONS[0]:
      case CORNER_SHELVES_POSITIONS[3]:
        return intl.formatMessage({id: "grohe.feature.top"})
      case CORNER_SHELVES_POSITIONS[1]:
      case CORNER_SHELVES_POSITIONS[4]:
        return intl.formatMessage({id: "grohe.feature.center"})
      case CORNER_SHELVES_POSITIONS[2]:
      case CORNER_SHELVES_POSITIONS[5]:
        return intl.formatMessage({id: "grohe.feature.bottom"})
      default:
        return metaValue
    }
  }

  return (
    <WithClickCount>
      {(maxClickCountReached) => (
        <Fragment>
          {Object.keys(leftRightArray).map((metaName) => (
            <div className="lk-feature__options" key={metaName}>
              <span className="lk-feature__options-title">
                <FormattedMessage id={"grohe.feature.placement." + metaName}/>:
              </span>
              <div className="lk-feature__options-list">
                {leftRightArray[metaName].map(position => {
                  const isActive = featureGroup.layerPositions[position];
                  return (
                    <Button className={"look-button look-button--half-radius look-button--option lk-type" + (isActive ? " look-button--option-active" : "")}
                            key={position}
                            onClick={() => optionsButtonClick(position, maxClickCountReached)}>
                      {getValueText(position)}
                    </Button>
                  )
                })}
              </div>
            </div>
          ))}
        </Fragment>
      )}
    </WithClickCount>
  )
};

GroheFeatureOptionsShelfSide.propTypes = {
  metaName: PropTypes.string,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    canvasCount,
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsShelfSide)
)
